import { formatter } from "../../utility";
import { readyCheckIcon, notReadyCheckIcon } from "../../assets/images";


const ValidationSummary = (props) => {
  const { 
    phase1RentIncreaseDate, calc_p1IsServiceDateValid, appliedPhase1EligibleAmount, calc_p1IsAppliedEligibleAmountValid, calc_p1MaxEligibleAmount, phase1RentAmount, calc_p1RentIncreaseErrorAmount, 
    calc_p1IsRentIncreaseAmountValid, calc_p1MaxAdditionalRentIncrease, calc_p1IsRemainingEligibleAmountValid, calc_p1RemainingEligibleAmount, remainingPhase1EligibleAmount  
  } = props?.validationData;
  
  const renderMinDateValidation = () => {
    const displayTextLandlord = calc_p1IsServiceDateValid ? 'The phase 1 rent increase was imposed at least 3 full months after the decision.' 
      : 'The phase 1 rent increase was not imposed at least 3 full months after the decision';
    const displayTextTenant = calc_p1IsServiceDateValid ? 'The phase 1 rent increase was imposed at least 3 full months after the decision with enough time to serve notice' 
      : 'The phase 1 rent increase was not imposed at least 3 full months after the decision and did not include adequate notice.'
    return (
      <div className="validator__summary__item">
        <div className="validator__summary__item__column-left">
          {formatter.toDateDisplay(phase1RentIncreaseDate, { fullMonth: true })}
        </div>
        <div className={`validator__summary__item__column-right${calc_p1IsServiceDateValid ? '' : '--error'}`}>
          {props?.isTenantRoute ? displayTextTenant : displayTextLandlord}
        </div>
      </div>
    )
  }

  const renderEligibleAmount = () => {
    const displayText = calc_p1IsAppliedEligibleAmountValid ? `The additional rent increase amount that was imposed is within the maximum rent increase allowed of ${formatter.toAmountDisplay(calc_p1MaxEligibleAmount)}.` 
      : `The additional rent increase amount that was imposed is over the maximum rent increase allowed of ${formatter.toAmountDisplay(calc_p1MaxEligibleAmount)}.`
    return (
      <div className="validator__summary__item">
        <div className="validator__summary__item__column-left">
          {formatter.toAmountDisplay(appliedPhase1EligibleAmount)}
        </div>
        <div className={`validator__summary__item__column-right${calc_p1IsAppliedEligibleAmountValid ? '' : '--error'}`}>
          {displayText}
        </div>
      </div>
    )
  }

  const renderRentIncreaseAmount = () => {
    const displayText = calc_p1IsRentIncreaseAmountValid ? `${props?.isTenantRoute ? 'The' : 'Your'} phase 1 rent increase is within the maximum rent increase allowed of ${formatter.toAmountDisplay(calc_p1MaxAdditionalRentIncrease)}.` 
      : `${props?.isTenantRoute ? 'The' : 'Your'} phase 1 rent increase is ${formatter.toAmountDisplay(calc_p1RentIncreaseErrorAmount)} over the maximum rent increase allowed of ${formatter.toAmountDisplay(calc_p1MaxAdditionalRentIncrease)}.`;
    return (
      <div className="validator__summary__item">
        <div className="validator__summary__item__column-left">
          {formatter.toAmountDisplay(phase1RentAmount)}
        </div>
        <div className={`validator__summary__item__column-right${calc_p1IsRentIncreaseAmountValid  ? '' : '--error'}`}>
          {displayText}
        </div>
      </div>
    )
  }

  const renderRemainingEligibleAmount = () => {
    const correctAmountDisplay = calc_p1RemainingEligibleAmount > 0 ? calc_p1RemainingEligibleAmount : 0;
    const displayText = calc_p1IsRemainingEligibleAmountValid ? `${props?.isTenantRoute ? 'The' : 'Your'} remaining eligible amount of ${formatter.toAmountDisplay(calc_p1RemainingEligibleAmount)} is correct.` 
      : `${props?.isTenantRoute ? 'The' : 'Your'} remaining eligible amount of ${formatter.toAmountDisplay(remainingPhase1EligibleAmount)} is not correct. The correct amount is ${formatter.toAmountDisplay(correctAmountDisplay)}.`;
    return (
      <div className="validator__summary__item">
        <div className="validator__summary__item__column-left">
          {formatter.toAmountDisplay(remainingPhase1EligibleAmount)}
        </div>
        <div className={`validator__summary__item__column-right${ calc_p1IsRemainingEligibleAmountValid ? '' : '--error'}`}>
          {displayText}
        </div>
      </div>
    )
  }

  const renderValidationSummary = () => {
    const processHadNoErrors = calc_p1IsServiceDateValid && calc_p1IsAppliedEligibleAmountValid && calc_p1IsRentIncreaseAmountValid && calc_p1IsRemainingEligibleAmountValid
    const displayText = processHadNoErrors ? 
      `Based on the information you provided, the phase 1 rent increase was imposed correctly` : 
      `Based on the information you provided, warnings were identified ${props?.isTenantRoute ? 'in the' : 'for your'} phase 1 rent increase. This may happen if the information
        you provided was not correct. You can click modify to change any incorrect information that you provided.`;
    
    return <p className={`validator__summary__item__outcome${processHadNoErrors ? '--success' : '--error'}`}>
      <img className="validator__summary__item__outcome__icon" src={processHadNoErrors ? readyCheckIcon : notReadyCheckIcon} alt=""/>
      {displayText}
    </p>;
  }

  return (
    <div className="validation__summary">
      <p className="breakdown-title">Phase 1 Rent Increase Validation</p>
      { renderMinDateValidation() }
      { renderEligibleAmount() }
      { renderRentIncreaseAmount() }
      { renderRemainingEligibleAmount() }
      { renderValidationSummary() }
    </div>
  )
}

export default ValidationSummary;